import labels from './labels';

/**
 * Simple labelling service due minimize bundle size
 * For more specific porpouse please consider https://github.com/stefalda/localized-strings
 *
 * @param key the key of the label to use
 */
const t = (key: string): string => {
  return labels[key] ? labels[key] : `*${key}`;
};

export default t;
